const config = {
  localStorageKey: `${process.env.NEXT_PUBLIC_BUILD}-set-connect-meetings-webview`,
  ios: {
    downloadURL: 'https://apps.apple.com/us/app/set-connect/id1625318415',
  },
  android: {
    downloadURL: 'https://play.google.com/store/apps/details?id=br.com.coclub.set',
  },
};
export default config;
